<template>
  <div
    class="fouter p-2 lg:p-6 fadeindown animation-duration-500 animation-iteration-1"
    id="fouter"
  >
    <div class=" overflow-hidden lg:flex justify-content-around">
      <div class="flex lg:block justify-content-center flex-column">
        <span class="flex align-items-center justify-content-center lg:justify-content-start">
          <i class="pi pi-user p-2"></i>
          <span>Giosuè Addario</span>
        </span>

        <span class="flex align-items-center justify-content-center lg:justify-content-start">
          <i class="pi pi-calendar p-2"></i>
          <span>31/08/1998</span>
        </span>

        <span class="flex align-items-center justify-content-center lg:justify-content-start">
          <i class="pi pi-home p-2"></i>
          <span>Aosta - Torino - Trieste</span>
        </span>
      </div>
      <div>
        <span class="flex align-items-center justify-content-center lg:justify-content-start">
          <i class="pi pi-phone p-2"></i>
          <span><a href="tel:+39 3280098770">+39 3280098770</a> </span>
        </span>

        <span class="flex align-items-center justify-content-center lg:justify-content-start">
          <i class="pi pi-comments p-2"></i>
          <span
            ><a href="mailto:gaddario98@gmail.com">gaddario98@gmail.com</a>
          </span>
        </span>
      </div>
      <div>
        <div
          class="flex align-items-center justify-content-center lg:justify-content-start"
          @click="
            visitLink(
              'https://l.facebook.com/l.php?u=https%3A%2F%2Flinkedin.com%2Fin%2Fgiosu%25C3%25A8-addario-3b5bb41a1%3Ffbclid%3DIwAR3j_3INav9n5aGWvpNbJjO2KJ9agPzjht0dn3YFmt_Xsv5s03SOLW28qnQ&h=AT23qlmDychJfH8ZISEcopLEeknr9UWECln96f9cqkiP6ZRZJ4SEunamGRkaD8jC2ZmtDu_vOfLNwUvn_xiybWuzeHNGXZA1211p0cmKL3crrxJciAEIFa73-6TaWkvrm-24'
            )
          "
        >
          <i class="pi pi-linkedin cursor-pointer p-2"></i>
          <span>LinkedIn</span>
        </div>
        <div
          class="flex align-items-center justify-content-center lg:justify-content-start"
          @click="visitLink('https://www.facebook.com/gaddario98')"
        >
          <i class="pi pi-facebook cursor-pointer p-2"></i>
          <span>Facebook</span>
        </div>
        <div
          class="flex align-items-center justify-content-center lg:justify-content-start"
          @click="
            visitLink(
              'https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.instagram.com%2Fgaddario98%3Ffbclid%3DIwAR0jr9pFy1QHZxLUajRyFL2-8sSqmhnfnRSDDtlCqxQWBQvkfL7efZ-To2Q&h=AT02IXVdbn7KC_0-YZsIdy6-KIS2Wr8NrMtkEVW-SKCimsQBDKx04gUGr2QLQgdHrfJA06ZfN5prONd_edgtVGzT_SIx3ssB7yadexJxgqfbhUFcBytChLzvmT3ByI7prQSy'
            )
          "
        >
          <i class="pi pi-instagram cursor-pointer p-2"></i>
          <span>Instagram</span>
        </div>
        <div
          class="flex align-items-center justify-content-center lg:justify-content-start"
          @click="
            visitLink(
              'https://l.facebook.com/l.php?u=https%3A%2F%2Ftwitter.com%2Fgaddario98%3Ffbclid%3DIwAR0RcwkwWVY2AuwMuOQIQ7iJqBAw-3wmDHKzkaKPW6gMh5QgKDRXuMHIk98&h=AT1Xy9wWk3ISElCr2NfH2AF-RM7ozp_zZxgsA2KpIpby7w3ScrVuo6tBjZtzay5V7cv0MYP_ojruiGrDHYe67ByIRJl-2WXzWB3mJowHc6-hkbpBaK8QFS4r5yMHApreF9M-'
            )
          "
        >
          <i class="pi pi-twitter cursor-pointer p-2"></i>
          <span>Twitter</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Fouter",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
  mounted() {
    document.documentElement.style.setProperty(
      "--heightFouter",
      document.getElementById("fouter").offsetHeight + "px"
    );
  },
  methods: {
    visitLink(link) {
      window.open(link, "_blanck");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only 
-->
<style scoped lang="scss">
.fouter {
  background: var(--color-1);
  text-align: center;
}
span,
i {
  font-size: 1.5rem;
}
h2 {
  font-size: 1.75rem;
}
</style>
